var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banned"},[_c('div',{staticClass:"banned_contentbox"},[_c('div',{staticClass:"banned_content_title"},[_vm._v("社区账号已被封禁")]),_c('div',{staticClass:"banned_content_con"},[_c('p',[_vm._v("亲爱的玩家，由于您多次發布违规内容，导致账号被封禁。")]),_c('p',[_vm._v("违规原因："+_vm._s(_vm.$store.state.bannedText))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }